import { Block, createFileRoute, Outlet } from '@tanstack/react-router'
import { useDocumentStore } from '@/stores/documentStore'
import { useCallback } from 'react'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/projects/$projectId/sops',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const isEditing = useDocumentStore((state) => state.isEditing)
  const setEditing = useDocumentStore((state) => state.setEditing)
  const reset = useDocumentStore((state) => state.reset)

  const shouldBlockFn = useCallback(
    (next: { pathname: string }, isEditing: boolean) => {
      if (!isEditing || next.pathname.includes('/sops/')) return false
      const shouldLeave = confirm(
        'Are you sure you want to leave? You have unsaved changes.',
      )
      if (shouldLeave) {
        reset()
        setEditing(false)
      }
      return !shouldLeave
    },
    [reset, setEditing],
  )

  return (
    <>
      {/* Navigation Blocking for if the user is still editing the form */}
      <Block
        shouldBlockFn={({ next }) => shouldBlockFn(next, isEditing)}
        disabled={!isEditing}
      />
      <Outlet />
    </>
  )
}
